export default __webpack_public_path__ + "static/media/guide.3a98e5b5.png";